export enum RequiredEnvParams {
  DATABASE_URL = 'DATABASE_URL',
  DATABASE_READER_URL = 'DATABASE_READER_URL',
  ENVIRONMENT_NAME = 'ENVIRONMENT_NAME',
  NEXT_PUBLIC_ENVIRONMENT_NAME = 'NEXT_PUBLIC_ENVIRONMENT_NAME',
  FRONTEGG_API_GATEWAY_URL = 'FRONTEGG_API_GATEWAY_URL',
  FRONTEGG_API_KEY = 'FRONTEGG_API_KEY',
  FRONTEGG_CLIENT_ID = 'FRONTEGG_CLIENT_ID',
  IDEON_API_KEY = 'IDEON_API_KEY',
  IDEON_API_URL = 'IDEON_API_URL',
  INVITE_JWT_KEY = 'INVITE_JWT_KEY',
  LYNX_API_URL = 'LYNX_API_URL',
  LYNX_ZORRO_CLIENT_ID = 'LYNX_ZORRO_CLIENT_ID',
  LYNX_ZORRO_CLIENT_SECRET = 'LYNX_ZORRO_CLIENT_SECRET',
  LYNX_ZORRO_CLIENT_NAME = 'LYNX_ZORRO_CLIENT_NAME',
  LYNX_ZORRO_PARENT_CLIENT_ORG_NAME = 'LYNX_ZORRO_PARENT_CLIENT_ORG_NAME',
  LYNX_PHYSICAL_CARD_PACKAGE_NAME = 'LYNX_PHYSICAL_CARD_PACKAGE_NAME',
  LYNX_VIRTUAL_CARD_PACKAGE_NAME = 'LYNX_VIRTUAL_CARD_PACKAGE_NAME',
  LYNX_MEMBER_VIRTUAL_CARD_PACKAGE_NAME = 'LYNX_MEMBER_VIRTUAL_CARD_PACKAGE_NAME',
  LYNX_ICHRA_PREM_ONLY_PLAN_NAME = 'LYNX_ICHRA_PREM_ONLY_PLAN_NAME',
  LYNX_ICHRA_PREM_PLUS_PLAN_NAME = 'LYNX_ICHRA_PREM_PLUS_PLAN_NAME',
  LYNX_WEBHOOK_RECEIVER_URL = 'LYNX_WEBHOOK_RECEIVER_URL',
  MONOLITH_API_KEY = 'MONOLITH_API_KEY',
  MONOLITH_PORT = 'MONOLITH_PORT',
  MONOLITH_URL = 'MONOLITH_URL',
  POSTGRES_DB = 'POSTGRES_DB',
  POSTGRES_HOST = 'POSTGRES_HOST',
  POSTGRES_PASSWORD = 'POSTGRES_PASSWORD',
  POSTGRES_PORT = 'POSTGRES_PORT',
  POSTGRES_USER = 'POSTGRES_USER',
  PRISMA_FIELD_ENCRYPTION_KEY = 'PRISMA_FIELD_ENCRYPTION_KEY',
  SLACK_APP_AUTH_TOKEN = 'SLACK_APP_AUTH_TOKEN',
  SLACK_SUBMISSIONS_CHANNEL_ID = 'SLACK_SUBMISSIONS_CHANNEL_ID',
  SLACK_DEMO_PRODUCT_NOTIFICATIONS_CHANNEL_ID = 'SLACK_DEMO_PRODUCT_NOTIFICATIONS_CHANNEL_ID',
  SLACK_PRODUCT_NOTIFICATIONS_CHANNEL_ID = 'SLACK_PRODUCT_NOTIFICATIONS_CHANNEL_ID',
  SLACK_SENTRY_NOTIFICATIONS_CHANNEL_ID = 'SLACK_SENTRY_NOTIFICATIONS_CHANNEL_ID',
  SLACK_SUPPORT_ISSUE_REPORTS_CHANNEL_ID = 'SLACK_SUPPORT_ISSUE_REPORTS_CHANNEL_ID',
  SLACK_FINCH_SYNC_CHANNEL_ID = 'SLACK_FINCH_SYNC_CHANNEL_ID',
  SPLIT_IO_API_KEY = 'SPLIT_IO_API_KEY',
  NEXT_PUBLIC_APP_BASE_URL = 'NEXT_PUBLIC_APP_BASE_URL',
  NEXT_PUBLIC_ZORRO_AGENCY_ID = 'NEXT_PUBLIC_ZORRO_AGENCY_ID',
  ECHO_PAYMENTS_BASE_URL = 'ECHO_PAYMENTS_BASE_URL',
  ECHO_PAYMENTS_CLIENT_ID = 'ECHO_PAYMENTS_CLIENT_ID',
  ECHO_PAYMENTS_CLIENT_SECRET = 'ECHO_PAYMENTS_CLIENT_SECRET',
  NEXT_PUBLIC_ZORRO_PY_BASE_URL = 'NEXT_PUBLIC_ZORRO_PY_BASE_URL',
  NEXT_PUBLIC_FILTER_EMPLOYER_ID = 'NEXT_PUBLIC_FILTER_EMPLOYER_ID',
  SLACK_NOTIFICATIONS_CUSTOMER_OPS_CHANNEL_ID = 'SLACK_NOTIFICATIONS_CUSTOMER_OPS_CHANNEL_ID',
  SLACK_NOTIFICATIONS_CUSTOMER_SUCCESS_CHANNEL_ID = 'SLACK_NOTIFICATIONS_CUSTOMER_SUCCESS_CHANNEL_ID',
  SLACK_NOTIFICATIONS_CUSTOMER_TEAMS_SILENT_CHANNEL_ID = 'SLACK_NOTIFICATIONS_CUSTOMER_TEAMS_SILENT_CHANNEL_ID',
  SLACK_NOTIFICATIONS_INTERCOM_SYNC_STATUS_CHANNEL_ID = 'SLACK_NOTIFICATIONS_INTERCOM_SYNC_STATUS_CHANNEL_ID',
  SLACK_NOTIFICATIONS_CARRIER_TABLES_CHANNEL_ID = 'SLACK_NOTIFICATIONS_CARRIER_TABLES_CHANNEL_ID',
  SLACK_FINCH_EMPLOYMENT_SYNC_CHANNEL_ID = 'SLACK_FINCH_EMPLOYMENT_SYNC_CHANNEL_ID',
  SLACK_PAYMENTS_INCIDENTS_CHANNEL_ID = 'SLACK_PAYMENTS_INCIDENTS_CHANNEL_ID',
  SLACK_PAYMENTS_OPS_CHANNEL_ID = 'SLACK_PAYMENTS_OPS_CHANNEL_ID',
  SLACK_ENROLL_CONNECT_ERRORS_CHANNEL_ID = 'SLACK_ENROLL_CONNECT_ERRORS_CHANNEL_ID',
  FRONTEGG_OMNIPOTENT_TENANT_CLIENT_ID = 'FRONTEGG_OMNIPOTENT_TENANT_CLIENT_ID',
  FRONTEGG_OMNIPOTENT_TENANT_SECRET = 'FRONTEGG_OMNIPOTENT_TENANT_SECRET',
  INTERNAL_DISCOVERY_API_KEY = 'INTERNAL_DISCOVERY_API_KEY',
}

export enum EnvParams {
  DEV_SEED_ENROLL = 'DEV_SEED_ENROLL',
  DEV_SEED_LYNX_EMPLOYER_CONFIG = 'DEV_SEED_LYNX_EMPLOYER_CONFIG',
  DEV_SEED_TENANT_FILTER = 'DEV_SEED_TENANT_FILTER',
  FRONTEGG_EMPLOYEE_ROLE_ID = 'FRONTEGG_EMPLOYEE_ROLE_ID',
  FRONTEGG_EMPLOYER_ADMIN_ROLE_ID = 'FRONTEGG_EMPLOYER_ADMIN_ROLE_ID',
  FRONTEGG_OMNIPOTENT_ADMIN_ROLE_ID = 'FRONTEGG_OMNIPOTENT_ADMIN_ROLE_ID',
  FRONTEGG_AGENT_ROLE_ID = 'FRONTEGG_AGENT_ROLE_ID',
  FRONTEGG_ACCOUNT_SUPERVISOR_ROLE_ID = 'FRONTEGG_ACCOUNT_SUPERVISOR_ROLE_ID',
  FRONTEGG_AGENCY_ADMIN_ROLE_ID = 'FRONTEGG_AGENCY_ADMIN_ROLE_ID',
  FRONTEGG_OPERATOR_ROLE_ID = 'FRONTEGG_OPERATOR_ROLE_ID',
  FRONTEGG_HOSTED_LOGIN = 'FRONTEGG_HOSTED_LOGIN',
  ZORRO_AWS_REGION = 'ZORRO_AWS_REGION',
  ZORRO_AWS_ACCESS_KEY_ID = 'ZORRO_AWS_ACCESS_KEY_ID',
  ZORRO_AWS_SECRET_ACCESS_KEY = 'ZORRO_AWS_SECRET_ACCESS_KEY',
  NEXT_PUBLIC_APP_BASE_URL = 'NEXT_PUBLIC_APP_BASE_URL',
  NEXT_PUBLIC_FULLSTORY_ORG_ID = 'NEXT_PUBLIC_FULLSTORY_ORG_ID',
  PINO_LOG_LEVEL = 'PINO_LOG_LEVEL',
  SENDGRID_API_KEY = 'SENDGRID_API_KEY',
  SENDGRID_EMAIL_FROM = 'SENDGRID_EMAIL_FROM',
  SENDGRID_EMAIL_FROM_NAME = 'SENDGRID_EMAIL_FROM_NAME',
  SENDGRID_SANDBOX = 'SENDGRID_SANDBOX',
  SENDGRID_SIGNUP_EMAIL_TEMPLATE_ID = 'SENDGRID_SIGNUP_EMAIL_TEMPLATE_ID',
  SENTRY_AUTH_TOKEN = 'SENTRY_AUTH_TOKEN',
  SENTRY_DSN = 'SENTRY_DSN',
  SENTRY_DSN_MONOLITH = 'SENTRY_DSN_MONOLITH',
  SENDGRID_SUBMIT_EMAIL_TEMPLATE_ID = 'SENDGRID_SUBMIT_EMAIL_TEMPLATE_ID',
  SENDGRID_WAIVE_EMAIL_TEMPLATE_ID = 'SENDGRID_WAIVE_EMAIL_TEMPLATE_ID',
  SENDGRID_ELECTION_WINDOW_LAUNCH_EMAIL_TEMPLATE_ID = 'SENDGRID_ELECTION_WINDOW_LAUNCH_EMAIL_TEMPLATE_ID',
  SENDGRID_ENROLLMENT_CONFIRMATION_EMAIL_TEMPLATE_ID = 'SENDGRID_ENROLLMENT_CONFIRMATION_EMAIL_TEMPLATE_ID',
  SENDGRID_ELECTION_REMINDER_EMAIL_TEMPLATE_ID = 'SENDGRID_ELECTION_REMINDER_EMAIL_TEMPLATE_ID',
  SENDGRID_ADMIN_QLE_EMAIL_TEMPLATE_ID = 'SENDGRID_ADMIN_QLE_EMAIL_TEMPLATE_ID',
  SENDGRID_AGENT_QLE_EMAIL_TEMPLATE_ID = 'SENDGRID_AGENT_QLE_EMAIL_TEMPLATE_ID',
  SENDGRID_AGENT_EMPLOYEE_TERMINATION_EMAIL_TEMPLATE_ID = 'SENDGRID_AGENT_EMPLOYEE_TERMINATION_EMAIL_TEMPLATE_ID',
  SENDGRID_COBRA_TERMINATION_EMAIL_TEMPLATE_ID = 'SENDGRID_COBRA_TERMINATION_EMAIL_TEMPLATE_ID',
  SENDGRID_USER_ACTIVATION_EMAIL_TEMPLATE_ID = 'SENDGRID_USER_ACTIVATION_EMAIL_TEMPLATE_ID',
  SENDGRID_AGENT_EMPLOYEE_LEAVE_OF_ABSENCE_EMAIL_TEMPLATE_ID = 'SENDGRID_AGENT_EMPLOYEE_LEAVE_OF_ABSENCE_EMAIL_TEMPLATE_ID',
  SENDGRID_AGENT_NEW_EMPLOYEE_EMAIL_TEMPLATE_ID = 'SENDGRID_AGENT_NEW_EMPLOYEE_EMAIL_TEMPLATE_ID',
  SENDGRID_AGENT_EMPLOYEE_SUBMISSION_EMAIL_TEMPLATE_ID = 'SENDGRID_AGENT_EMPLOYEE_SUBMISSION_EMAIL_TEMPLATE_ID',
  SENDGRID_AGENT_EMPLOYEE_SUBMISSION_RENEWAL_EMAIL_TEMPLATE_ID = 'SENDGRID_AGENT_EMPLOYEE_SUBMISSION_RENEWAL_EMAIL_TEMPLATE_ID',
  SENDGRID_AGENT_EMPLOYEE_SUBMISSION_RENEWAL_WAIVED_EMAIL_TEMPLATE_ID = 'SENDGRID_AGENT_EMPLOYEE_SUBMISSION_RENEWAL_WAIVED_EMAIL_TEMPLATE_ID',
  SENDGRID_PAYMENTS_PAYMENT_METHOD_SUCCESSFULLY_CREATED = 'SENDGRID_PAYMENTS_PAYMENT_METHOD_SUCCESSFULLY_CREATED',
  SENDGRID_PAYMENTS_CONFIRMATION_APPLICATION_TEMPLATE_ID = 'SENDGRID_PAYMENTS_CONFIRMATION_APPLICATION_TEMPLATE_ID',
  SENDGRID_PAYMENTS_CONFIRMATION_PAYMENT_TEMPLATE_ID = 'SENDGRID_PAYMENTS_CONFIRMATION_PAYMENT_TEMPLATE_ID',
  SENDGRID_PAYMENTS_CONFIRMATION_APPLICATION_AND_PAYMENT_TEMPLATE_ID = 'SENDGRID_PAYMENTS_CONFIRMATION_APPLICATION_AND_PAYMENT_TEMPLATE_ID',
  SENDGRID_ADD_EMPLOYER_EMAIL_TEMPLATE_ID = 'SENDGRID_ADD_EMPLOYER_EMAIL_TEMPLATE_ID',
  SENDGRID_UPDATE_EMPLOYER_STATUS_NEEDS_REVIEW_EMAIL_TEMPLATE_ID = 'SENDGRID_UPDATE_EMPLOYER_STATUS_NEEDS_REVIEW_EMAIL_TEMPLATE_ID',
  SENDGRID_UPDATE_EMPLOYER_STATUS_ACTIVE_AGENT_EMAIL_TEMPLATE_ID = 'SENDGRID_UPDATE_EMPLOYER_STATUS_ACTIVE_AGENT_EMAIL_TEMPLATE_ID',
  SENDGRID_UPDATE_EMPLOYER_STATUS_ACTIVE_ADMIN_EMAIL_TEMPLATE_ID = 'SENDGRID_UPDATE_EMPLOYER_STATUS_ACTIVE_ADMIN_EMAIL_TEMPLATE_ID',
  SENDGRID_BULK_EMPLOYEE_UPDATE_TEMPLATE_ID = 'SENDGRID_BULK_EMPLOYEE_UPDATE_TEMPLATE_ID',
  SENDGRID_ELECTION_SUBMITTED_SUMMARY_GENERIC_TEMPLATE_ID = 'SENDGRID_ELECTION_SUBMITTED_SUMMARY_GENERIC_TEMPLATE_ID',
  SENDGRID_ELECTION_SUBMITTED_AOR_SELF_ENROLL_TEMPLATE_ID = 'SENDGRID_ELECTION_SUBMITTED_AOR_SELF_ENROLL_TEMPLATE_ID',
  SENDGRID_ELECTION_SUBMITTED_AOR_TEMPLATE_ID = 'SENDGRID_ELECTION_SUBMITTED_AOR_TEMPLATE_ID',
  SENDGRID_ELECTION_SUBMITTED_SELF_ENROLL_TEMPLATE_ID = 'SENDGRID_ELECTION_SUBMITTED_SELF_ENROLL_TEMPLATE_ID',
  SENDGRID_ELECTION_SUBMITTED_ONLY_NEXT_STEPS_TEMPLATE_ID = 'SENDGRID_ELECTION_SUBMITTED_ONLY_NEXT_STEPS_TEMPLATE_ID',
  SENDGRID_CARRIER_APPLICATION_SENT_TEMPLATE_ID = 'SENDGRID_CARRIER_APPLICATION_SENT_TEMPLATE_ID',
  SENDGRID_CONFIRMATION_GENERIC_TEMPLATE_ID = 'SENDGRID_CONFIRMATION_GENERIC_TEMPLATE_ID',
  SENDGRID_CONFIRMATION_ONLY_INITIAL_PAYMENT_TEMPLATE_ID = 'SENDGRID_CONFIRMATION_ONLY_INITIAL_PAYMENT_TEMPLATE_ID',
  SENDGRID_CONFIRMATION_ONLY_AUTO_PAY_TEMPLATE_ID = 'SENDGRID_CONFIRMATION_ONLY_AUTO_PAY_TEMPLATE_ID',
  SENDGRID_CONFIRMATION_INITIAL_AUTO_PAY_TEMPLATE_ID = 'SENDGRID_CONFIRMATION_INITIAL_AUTO_PAY_TEMPLATE_ID',
  SENDGRID_PAYMENT_COMMS_EMAIL_TEMPLATE_ID = 'SENDGRID_PAYMENT_COMMS_EMAIL_TEMPLATE_ID',
  SENDGRID_EMERGENCY_RESERVE_PULL_EMAIL_TEMPLATE_ID = 'SENDGRID_EMERGENCY_RESERVE_PULL_EMAIL_TEMPLATE_ID',
  INTERCOM_ACCESS_TOKEN = 'INTERCOM_ACCESS_TOKEN',
  INTERCOM_SECRET_KEY = 'INTERCOM_SECRET_KEY',
  HEALTH_SHERPA_API_URL = 'HEALTH_SHERPA_API_URL',
  HEALTH_SHERPA_AGENT_ID = 'HEALTH_SHERPA_AGENT_ID',
  HEALTH_SHERPA_ENROLLCONNECT_API_URL = 'HEALTH_SHERPA_ENROLLCONNECT_API_URL',
  HEALTH_SHERPA_ENROLLCONNECT_API_KEY = 'HEALTH_SHERPA_ENROLLCONNECT_API_KEY',
  HEALTH_SHERPA_WEBHOOK_API_KEY = 'HEALTH_SHERPA_WEBHOOK_API_KEY',
  HEALTH_SHERPA_DEEPLINK_BASIC_AUTH = 'HEALTH_SHERPA_DEEPLINK_BASIC_AUTH',
  HEALTH_SHERPA_ELEVANCE_CARRIER_PRODUCER_CODE = 'HEALTH_SHERPA_ELEVANCE_CARRIER_PRODUCER_CODE',
  HSA_SERVICE_BASE_URL = 'HSA_SERVICE_BASE_URL',
  HSA_USER_ID = 'HSA_USER_ID',
  HSA_PASSWORD = 'HSA_PASSWORD',
  GOOGLE_SERVICE_ACCOUNT_JSON_PRIVATE_KEY = 'GOOGLE_SERVICE_ACCOUNT_JSON_PRIVATE_KEY',
  GOOGLE_SERVICE_ACCOUNT_JSON_CLIENT_EMAIL = 'GOOGLE_SERVICE_ACCOUNT_JSON_CLIENT_EMAIL',
  FINCH_BASE_URL = 'FINCH_BASE_URL',
  FINCH_CLIENT_ID = 'FINCH_CLIENT_ID',
  FINCH_CLIENT_SECRET = 'FINCH_CLIENT_SECRET',
  FINCH_MATCH_FAILURE_ALLOWLIST = 'FINCH_MATCH_FAILURE_ALLOWLIST',
  NEXT_PUBLIC_FINCH_CLIENT_MANUAL = 'NEXT_PUBLIC_FINCH_CLIENT_MANUAL',
  NEXT_PUBLIC_FINCH_CLIENT_SANDBOX = 'NEXT_PUBLIC_FINCH_CLIENT_SANDBOX',
  E2E_EMPLOYEE_TEST_PASSWORD = 'E2E_EMPLOYEE_TEST_PASSWORD',
  E2E_EMPLOYEE_TEST_EMAIL = 'E2E_EMPLOYEE_TEST_EMAIL',
  E2E_OMNIPOTENT_ADMIN_TEST_PASSWORD = 'E2E_OMNIPOTENT_ADMIN_TEST_PASSWORD',
  E2E_OMNIPOTENT_ADMIN_TEST_EMAIL = 'E2E_OMNIPOTENT_ADMIN_TEST_EMAIL',
  E2E_EMPLOYER_TEST_PASSWORD = 'E2E_EMPLOYER_TEST_PASSWORD',
  E2E_EMPLOYER_TEST_EMAIL = 'E2E_EMPLOYER_TEST_EMAIL',
  E2E_AGENT_ACCOUNT_SUPERVISOR_TEST_PASSWORD = 'E2E_AGENT_ACCOUNT_SUPERVISOR_TEST_PASSWORD',
  E2E_AGENT_ACCOUNT_SUPERVISOR_TEST_EMAIL = 'E2E_AGENT_ACCOUNT_SUPERVISOR_TEST_EMAIL',
  E2E_AGENT_TEST_EMAIL = 'E2E_AGENT_TEST_EMAIL',
  E2E_AGENT_TEST_PASSWORD = 'E2E_AGENT_TEST_PASSWORD',
  E2E_DEFAULT_COMPANY_NAME = 'E2E_DEFAULT_COMPANY_NAME',
  E2E_ENROLLMENT_TEAM = 'E2E_ENROLLMENT_TEAM',
  E2E_PRODUCER_AGENCY = 'E2E_PRODUCER_AGENCY',
  METRICS_API_KEY = 'METRICS_API_KEY',
  ANVIL_API_KEY = 'ANVIL_API_KEY',
  TWILIO_WEBHOOK_SECRET = 'TWILIO_WEBHOOK_SECRET',
  ZORRO_MANAGED_ENROLLMENT_TEAM_IDS = 'ZORRO_MANAGED_ENROLLMENT_TEAM_IDS',
  GRAPHILE_WORKER_CONCURRENCY = 'GRAPHILE_WORKER_CONCURRENCY',
  AXIOM_TOKEN = 'AXIOM_TOKEN',
  ENABLE_AXIOM_LOGGING = 'ENABLE_AXIOM_LOGGING',
  QUOTIT_API_URL = 'QUOTIT_API_URL',
  QUOTIT_REMOTE_ACCESS_KEY = 'QUOTIT_REMOTE_ACCESS_KEY',
  QUOTIT_WEBSITE_ACCESS_KEY = 'QUOTIT_WEBSITE_ACCESS_KEY',
  QUOTIT_BROKER_ID = 'QUOTIT_BROKER_ID',
  ENABLE_OTEL = 'ENABLE_OTEL',
  OTEL_EXPORTER_OTLP_ENDPOINT = 'OTEL_EXPORTER_OTLP_ENDPOINT',
  QUOTIT_ALLSTATE_CARRIER_IDS = 'QUOTIT_ALLSTATE_CARRIER_IDS',
  QUOTIT_ALLSTATE_STATES = 'QUOTIT_ALLSTATE_STATES',
  APP_VERSION = 'APP_VERSION',
  VERBOSE_REQUEST_LOGGING = 'VERBOSE_REQUEST_LOGGING',
  DISABLE_DEBUG_ENDPOINTS = 'DISABLE_DEBUG_ENDPOINTS',
  DATABASE_STATEMENT_TIMEOUT_MS = 'DATABASE_STATEMENT_TIMEOUT_MS',
  DATABASE_IDLE_IN_TRANSACTION_SESSION_TIMEOUT_MS = 'DATABASE_IDLE_IN_TRANSACTION_SESSION_TIMEOUT_MS',
  DATABASE_TRANSACTION_TIMEOUT_MS = 'DATABASE_TRANSACTION_TIMEOUT_MS',
  DATABASE_READER_STATEMENT_TIMEOUT_MS = 'DATABASE_READER_STATEMENT_TIMEOUT_MS',
  DATABASE_READER_IDLE_IN_TRANSACTION_SESSION_TIMEOUT_MS = 'DATABASE_READER_IDLE_IN_TRANSACTION_SESSION_TIMEOUT_MS',
  DATABASE_READER_TRANSACTION_TIMEOUT_MS = 'DATABASE_READER_TRANSACTION_TIMEOUT_MS',
}

export enum Environments {
  DEVELOPMENT = 'development',
  TEST = 'test',
  PRODUCTION = 'production',
}

export function environmentName() {
  return (
    process.env[RequiredEnvParams.ENVIRONMENT_NAME] ||
    process.env[RequiredEnvParams.NEXT_PUBLIC_ENVIRONMENT_NAME]
  );
}

export function stackName() {
  const envName = environmentName();
  switch (envName) {
    case Environments.DEVELOPMENT: {
      return 'development';
    }
    case Environments.TEST: {
      return 'test';
    }
    case Environments.PRODUCTION: {
      return 'prod';
    }
    default: {
      return envName;
    }
  }
}

export function isProductionEnvironment() {
  return environmentName() === Environments.PRODUCTION;
}

export function isTestEnvironment() {
  return environmentName() === Environments.TEST;
}

export function isDevelopmentEnvironment() {
  return environmentName() === Environments.DEVELOPMENT;
}

export const appVersion = process.env[EnvParams.APP_VERSION] || 'unknown';
